/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Please_SelectInputs */

const en_admin_resource_form_please_select = /** @type {(inputs: Admin_Resource_Form_Please_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select`)
};

const de_admin_resource_form_please_select = /** @type {(inputs: Admin_Resource_Form_Please_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wähle aus`)
};

const es_admin_resource_form_please_select = /** @type {(inputs: Admin_Resource_Form_Please_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecciona`)
};

const fr_admin_resource_form_please_select = /** @type {(inputs: Admin_Resource_Form_Please_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner`)
};

const nl_admin_resource_form_please_select = /** @type {(inputs: Admin_Resource_Form_Please_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer`)
};

/** @type {(inputs: Admin_Resource_Form_Please_SelectInputs) => LocalizedString} */
const it_admin_resource_form_please_select = en_admin_resource_form_please_select;

/** @type {(inputs: Admin_Resource_Form_Please_SelectInputs) => LocalizedString} */
const pt_br2_admin_resource_form_please_select = en_admin_resource_form_please_select;

/** @type {(inputs: Admin_Resource_Form_Please_SelectInputs) => LocalizedString} */
const pl_admin_resource_form_please_select = en_admin_resource_form_please_select;

/** @type {(inputs: Admin_Resource_Form_Please_SelectInputs) => LocalizedString} */
const hu_admin_resource_form_please_select = en_admin_resource_form_please_select;

/** @type {(inputs: Admin_Resource_Form_Please_SelectInputs) => LocalizedString} */
const ro_admin_resource_form_please_select = en_admin_resource_form_please_select;

/**
* | output |
* | --- |
* | "Please select" |
*
* @param {Admin_Resource_Form_Please_SelectInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_please_select = /** @type {((inputs?: Admin_Resource_Form_Please_SelectInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Please_SelectInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_please_select(inputs)
	if (locale === "de") return de_admin_resource_form_please_select(inputs)
	if (locale === "es") return es_admin_resource_form_please_select(inputs)
	if (locale === "fr") return fr_admin_resource_form_please_select(inputs)
	if (locale === "nl") return nl_admin_resource_form_please_select(inputs)
	if (locale === "it") return it_admin_resource_form_please_select(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_please_select(inputs)
	if (locale === "pl") return pl_admin_resource_form_please_select(inputs)
	if (locale === "hu") return hu_admin_resource_form_please_select(inputs)
	return ro_admin_resource_form_please_select(inputs)
});
export { admin_resource_form_please_select as "admin.resource_form.please_select" }